export const STORAGE_KEY = 'USER_LIST';

// Initial State
export const initialState = {
  results: [],
};

// Action Types
export const types = {
  LOAD_USERS: 'USER/LOAD_USERS',
  LOAD_USERS_SUCCESS: 'USER/LOAD_USERS_SUCCESS',

  SAVE_USERS: 'USER/SAVE_USERS',
  SAVE_USERS_SUCCESS: 'USER/SAVE_USERS_SUCCESS',
  SAVE_USERS_FAILED: 'USER/SAVE_USERS_FAILED',

  REMOVE_USER: 'USER/REMOVE_USER',
  REMOVE_USER_SUCCESS: 'USER/REMOVE_USER_SUCCESS',

  ADD_USER: 'USER/ADD_USER',
  ADD_USER_SUCCESS: 'USER/ADD_USER_SUCCESS',
  ADD_USER_PLACEHOLDER: 'USER/ADD_USER_PLACEHOLDER',

  FETCH_USER: 'USER/FETCH_USER',
  FETCH_USER_SUCCESS: 'USER/FETCH_USER_SUCCESS',
  FETCH_USER_FAILED: 'USER/FETCH_USER_FAILED',

  FETCH_USERS: 'USER/FETCH_USERS',
  FETCH_USERS_SUCCESS: 'USER/FETCH_USERS_SUCCESS',
  FETCH_USERS_FAILED: 'USER/FETCH_USERS_FAILED',
};

// Actions
export const actions = {
  loadUsers: () => ({ type: types.LOAD_USERS }),
  saveUsers: users => ({ type: types.SAVE_USERS, payload: { users } }),
  addUser: name => ({ type: types.ADD_USER, payload: { name } }),
  removeUser: id => ({ type: types.REMOVE_USER, payload: { id } }),
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case types.LOAD_USERS_SUCCESS:
      return {
        ...state,
        results: [...action.payload.users],
      };

    case types.SAVE_USERS_SUCCESS:
      return {
        ...state,
        results: [...action.payload.users],
      };

    case types.ADD_USER_SUCCESS:
      return {
        ...state,
        results: [...action.payload.users],
      };

    case types.FETCH_USERS_SUCCESS:
      return {
        ...state,
        results: [...action.payload.users],
      };

    case types.FETCH_USER_FAILED:
      return state;

    case types.ADD_USER_PLACEHOLDER:
      return {
        ...state,
        results: [...action.payload.users],
      };

    // Fallback
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js